var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _c("div", { staticClass: "row mat24 flex-nowrap" }, [
      _c(
        "div",
        { staticClass: "side-bar none-mobile" },
        [
          _c(
            "base-button-group",
            _vm._l(_vm.languages, function (lang) {
              return _c(
                "base-button",
                {
                  key: lang.code,
                  class: {
                    "is-active-lang": lang.code === _vm.currentLanguage,
                  },
                  attrs: { btn11: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToLanguage(lang)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "lang-btn" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(lang.label) +
                          " | " +
                          _vm._s(lang.code.toUpperCase())
                      ),
                    ]),
                    _c("i", {
                      staticClass: "fa fa-circle lang-status",
                      class: _vm.isLanguageEnabled(lang.code)
                        ? "lang-status--on"
                        : "lang-status--off",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content-wrap" },
        [
          _c(
            "div",
            { staticClass: "mobile-lang-nav none-desktop mab16" },
            _vm._l(_vm.languages, function (lang) {
              return _c(
                "base-button",
                {
                  key: `m-${lang.code}`,
                  staticClass: "mab8",
                  class: {
                    "is-active-lang": lang.code === _vm.currentLanguage,
                  },
                  attrs: { btn11: "", short: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToLanguage(lang)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(lang.code.toUpperCase()) + " "),
                  _c("i", {
                    staticClass: "fa fa-circle lang-status",
                    class: _vm.isLanguageEnabled(lang.code)
                      ? "lang-status--on"
                      : "lang-status--off",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              )
            }),
            1
          ),
          _c(
            "div",
            { ref: "saveFeedback" },
            [
              _vm.successMessage
                ? _c("panel-info-box", { staticClass: "mab16" }, [
                    _c("p", { staticClass: "text-lg" }, [
                      _c("b", [_vm._v(_vm._s(_vm.successMessage))]),
                    ]),
                  ])
                : _vm._e(),
              _vm.errorMessage
                ? _c("panel-info-box", { staticClass: "mab16" }, [
                    _c("p", { staticClass: "text-lg" }, [
                      _c("b", [_vm._v(_vm._s(_vm.errorMessage))]),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.loading
            ? _c("div", { staticClass: "row mat16" }, [_vm._m(1)])
            : _vm.form
            ? [
                _c("panel-competition-form-box", [
                  _c("div", { staticClass: "lang-header" }, [
                    _c("p", { staticClass: "lang-header__title" }, [
                      _vm._v(_vm._s(_vm.currentLanguageTitle)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "lang-header__toggle" },
                      [
                        _c("panel-input-switch", {
                          attrs: {
                            value: _vm.languageEnabled,
                            name: "languageEnabled",
                            label: "",
                            options: _vm.toggleOptions,
                          },
                          on: { input: _vm.onToggle },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("panel-competition-languages-form", {
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "actions-wrap" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: { btn1: "", short: "", disabled: _vm.saving },
                        on: { click: _vm.save },
                      },
                      [
                        !_vm.saving
                          ? _c("span", [_vm._v("Zapisz")])
                          : _c("span", [_vm._v("Zapisywanie...")]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mat32" }, [
      _c("div", { staticClass: "col-12 title" }, [_vm._v("Wersje językowe")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }